import React from 'react';

export const GovernancePage: React.FC = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-white text-center mb-8">
          Governance
        </h1>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-surface border border-border rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              IDNGOLD Governance Model
            </h2>
            <p className="text-text-secondary mb-6">
              IDNGOLD implements a decentralized governance model that allows token holders to participate in decision-making processes.
            </p>
            
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-white mb-3">Voting Rights</h3>
                <ul className="space-y-2 text-text-secondary">
                  <li>• 1 IDNGOLD = 1 vote</li>
                  <li>• Voting on major platform decisions</li>
                  <li>• Proposal submission rights (minimum 10,000 IDNGOLD)</li>
                  <li>• Quorum requirements for voting validity</li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-white mb-3">Governance Areas</h3>
                <ul className="space-y-2 text-text-secondary">
                  <li>• Fee structure adjustments</li>
                  <li>• New feature implementations</li>
                  <li>• Partnership decisions</li>
                  <li>• Treasury management</li>
                  <li>• Protocol upgrades</li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-white mb-3">Proposal Process</h3>
                <ol className="space-y-2 text-text-secondary">
                  <li>1. Submit proposal with detailed description</li>
                  <li>2. Community discussion period (7 days)</li>
                  <li>3. Voting period (7 days)</li>
                  <li>4. Implementation if approved</li>
                </ol>
              </div>
            </div>
          </div>
          
          <div className="bg-surface border border-border rounded-lg p-8 mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              DAO Structure
            </h2>
            <p className="text-text-secondary mb-4">
              The IDNGOLD DAO (Decentralized Autonomous Organization) manages the platform's evolution and treasury.
            </p>
            
            <div className="space-y-4">
              <div className="flex justify-between items-center py-2 border-b border-border">
                <span className="text-text-secondary">Treasury Management</span>
                <span className="text-gold font-medium">Community Voting</span>
              </div>
              
              <div className="flex justify-between items-center py-2 border-b border-border">
                <span className="text-text-secondary">Protocol Upgrades</span>
                <span className="text-gold font-medium">Token Holder Voting</span>
              </div>
              
              <div className="flex justify-between items-center py-2 border-b border-border">
                <span className="text-text-secondary">Fee Adjustments</span>
                <span className="text-gold font-medium">DAO Council</span>
              </div>
              
              <div className="flex justify-between items-center py-2">
                <span className="text-text-secondary">Emergency Measures</span>
                <span className="text-gold font-medium">Multi-sig Required</span>
              </div>
            </div>
          </div>
          
          <div className="bg-surface border border-border rounded-lg p-8">
            <h2 className="text-2xl font-semibold text-white mb-4">
              Council Members
            </h2>
            <p className="text-text-secondary mb-4">
              The DAO Council consists of elected community members responsible for day-to-day operations.
            </p>
            
            <div className="space-y-4">
              <div className="mb-4">
                <h3 className="text-lg font-medium text-white mb-2">Council Responsibilities</h3>
                <ul className="space-y-2 text-text-secondary">
                  <li>• Execute approved proposals</li>
                  <li>• Manage community communications</li>
                  <li>• Oversee technical implementations</li>
                  <li>• Report to the community</li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-lg font-medium text-white mb-2">Election Process</h3>
                <ul className="space-y-2 text-text-secondary">
                  <li>• Quarterly elections</li>
                  <li>• Community nominations</li>
                  <li>• Token holder voting</li>
                  <li>• 6-month term limits</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};